// GENERATED FILE - DO NOT MODIFY
export enum RequisitionProcessStatus {
    None = 0,
    Partially = 1,
    Completely = 2,
}

export let nameof = "RequisitionProcessStatus";
